import { gridSize, gridSizeConst12 } from "@/shared";
import {
  Button,
  FormControl,
  Grid,
  InputAdornment,
  TextField,
  TextFieldProps,
} from "@mui/material";
import { useState } from "react";
import { Controller } from "react-hook-form";
import { ScrollableDialogProps } from "./Dialogs";

type CustomModalObservacionFormProps = {
  label: string;
  //texto?: string;
  title: string;
  size?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  };
  register?: TextFieldProps;
  control: any;
  name: string;
  defaultValue?: string;
  onChangeValue?: (value: any, valid?: boolean) => void;
  sizeTextField?: "medium" | "small";
};

export default function CustomModalObservacionForm({
  label,
  //texto,
  size = gridSize,
  control,
  name,
  defaultValue = "",
  onChangeValue,
  sizeTextField = "medium",
  title,
}: CustomModalObservacionFormProps) {
  const [isOpenModal, setIsOpenModal] = useState(false);

  return (
    <>
      <Grid item {...size}>
        <FormControl fullWidth>
          <Controller
            control={control}
            name={name}
            defaultValue={defaultValue}
            render={({ field }) => {
              const isShort = field.value?.length <= 20;
              const textoResumido = isShort
                ? field.value
                : field.value?.substring(0, 20) + "...";

              const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
                field.onChange(e);
                onChangeValue?.(e.target.value, true);
              };

              return (
                <TextField
                  {...field}
                  label={label}
                  value={textoResumido}
                  onChange={handleChange}
                  variant="outlined"
                  fullWidth
                  multiline
                  size={sizeTextField}
                  InputProps={{
                    readOnly: isShort,
                    endAdornment: !isShort ? (
                      <InputAdornment position="end">
                        <Button
                          size="small"
                          onClick={() => setIsOpenModal(true)}
                        >
                          {'Ver todo'}
                        </Button>
                      </InputAdornment>
                    ) : undefined,
                  }}
                />
              );
            }}
          />
        </FormControl>
      </Grid>

      {isOpenModal && (
        <ScrollableDialogProps
          open={isOpenModal}
          title={title}
          onCloseIcon={() => setIsOpenModal(false)}
          minWidth="48%"
          contentNode={
            <Grid container spacing={2}>
              <Grid item {...gridSizeConst12}>
                <Controller
                  control={control}
                  name={name}
                  defaultValue={defaultValue}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label={label}
                      fullWidth
                      multiline
                      rows={6}
                      variant="outlined"
                      InputProps={{readOnly: true}}
                      onChange={(e) => {
                        field.onChange(e);
                        onChangeValue?.(e.target.value, true);
                      }}
                      //disabled={true}
                    />
                  )}
                />
              </Grid>
            </Grid>
          }
        />
      )}
    </>
  );
}
